import type { FC } from "react";
import React from "react";
import { Navigate } from "react-router-dom";

import { hasValue } from "@core/foundation/types";

import { ErrorView, LoadingView } from "@react/foundation/placeholder";

import { router } from "../../../bootstrap/router.ts";
import {
  signinOnReturnSelectors,
  useSigninOnReturnStore,
} from "../state/signin-on-return.ts";

export const AuthCallbackView: FC = () => {
  const error = useSigninOnReturnStore(signinOnReturnSelectors.error);

  const isPending = useSigninOnReturnStore(signinOnReturnSelectors.isPending);

  if (isPending) {
    return <LoadingView />;
  }

  if (hasValue(error)) {
    return <ErrorView description={error} />;
  }

  return <Navigate replace to={router.getUrl("Home")} />;
};
